export default {
  Authorised: 'Authorised',
  Cancelled: 'Cancelled',
  Closed: 'Closed',
  ClosedTotalLoss : 'Closed - Total Loss',
  Created: 'Created',
  PendingAuth: 'Pending Auth',
  PotentialTotalLoss: 'Potential Total Loss',
  ReopenedSuppAdded: 'Reopened - Supp Added',
  RFQReceived: 'RFQ Received',
  RFQSent: 'RFQ Sent',
  SuppAuthRejected: 'Supp Auth. Rejected',
  SuppNotAuthorised: 'Supp Not Authorised',
  SuppAuthorised: 'Supp Authorised',
  SuppPendingAuth: 'Supp Pending Auth',
  SupplementaryAdded: 'Supplementary Added',
  AssessedWithoutPrejudice: 'Assessed without Prejudice',
  RFQReviseQuote: 'RFQ Received. Revise Quote',
  TotalLoss: 'Total Loss',
  NotAuthorised: 'Not Authorised',
  RequestforRevisedSupp: 'Request for Revised Supp',
  CashSettlement: 'Cash Settlement',
  RFQCancelled : 'RFQ Cancelled',
  Completed: 'Completed',
  Submitted: 'Submitted',
  SuppRequestAssessment: 'Supp Request for assessment',
  RequestAssessment: 'Request for assessment'
}
